import React from "react";
import { GetTable } from "../../common/components/DataTable"
import DatesHelper from "../../common/datesHelper";
import { InterventoDto } from "../../generated";
import { confirmMessage, messageAlert } from "../../common/components/confirm";
import InterventiActions from "../InterventiActions";
import TechnicianViewer from "../../technicians/components/TechnicianViewer";
import { safebind } from "../../common/helpers";
const Table = GetTable<InterventoDto>();

interface Props {
    interventi: InterventoDto[];
    style?: React.CSSProperties
}

export class InterventiTable extends React.Component<Props> {
    onDeleteIntervento = async (intervento: InterventoDto) => {
        if (await confirmMessage(`Sei sicuro di voler eliminare l'intervento ${intervento.oggettoIntervento} del ${DatesHelper.getReadableDateString(intervento.dataIntervento)}?`, "Elimina intervento")) {
            let result = await InterventiActions.delete(intervento.idCliente, intervento.idIntervento);
            if (!result.deleteOk) {
                messageAlert("Si sono verificati dei problemi in fase di eliminazione dell'intervento. Contattare l'assistenza.", "Elimina intervento")
            }
        }
    }
    render() {
        const { interventi, style } = this.props;
        return (
            <Table
                keySelector={x => x.idIntervento.toString()}
                data={interventi}
                style={style}
            >
                <Table.Column
                    header="Data Intervento"
                    orderable groupable={false}
                    template={intervento => DatesHelper.getReadableDateTimeString(intervento.dataIntervento)}
                />
                <Table.Column
                    header="Tipo Intervento"
                    orderable groupable
                    template={intervento => intervento.tipoIntervento?.descTipoIntervento}
                />
                <Table.Column
                    header="Oggetto Intervento"
                    orderable groupable
                    template={intervento => intervento.oggettoIntervento}
                />
                <Table.Column
                    header="Identificativo"
                    orderable groupable
                    template={intervento => intervento.identificativoIntervento}
                />
                <Table.Column
                    header="Tecnico"
                    orderable groupable
                    template={intervento => <TechnicianViewer id={intervento.idTechnician} template={x => `${x.firstName} ${x.lastName}`} />}
                />
                <Table.Column
                    orderable={false}
                    groupable={false}
                    template={i => <button className="btn btn-outline-danger"
                        onClick={safebind(this.onDeleteIntervento, this, i)}><i className="fas fa-trash" />
                    </button>}
                />
            </Table>
        );
    }
}
